import { Injectable } from '@angular/core';
import { SanitizationService } from './sanitization.service';
import { Chart } from 'chart.js';

@Injectable({
  providedIn: 'root'
})
export class ChartToolTipServiceService {
  _chart: Chart;
  sanitization: SanitizationService;

  constructor(sanitization: SanitizationService) {
    this.sanitization = sanitization;
  }

  // v4-compatible external tooltip callback — receives {chart, tooltip} context
  customChartToolTip = (context: any) => {
    const { chart, tooltip: tooltipModel } = context;

    var tooltipEl: any = document.getElementById('chartjs-tooltip');

    const tableStyle = `
      background-color: rgba(33, 33, 33, 0.8);
      color: #ffffff; 
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 14px;
    `;

    const contentStyle = `
      font-size: 14px !important;
      margin: 3px;
    `;

    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      const sanitizedTable = this.sanitization.sanitizeHtml(`<table style="${tableStyle}"></table>`);
      tooltipEl.innerHTML = sanitizedTable as string;
      document.body.appendChild(tooltipEl);
    }

    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    if (tooltipModel.body) {
      var titleLines = tooltipModel.title || [];
      var bodyLines = tooltipModel.body.map((bodyItem) => bodyItem.lines);

      var innerHtml = '<thead><tr>';

      titleLines.forEach(function (title: any) {
        if (title.includes(",")) {
          let splitedTitle = title.split(",");
          innerHtml += `
            <th>
              <span style="${contentStyle}">${splitedTitle[0]}</span>
            </th>
            <th>
              <span style="${contentStyle}">${splitedTitle[1]}</span>
            </th>`;
        } else {
          innerHtml += `
            <th>
              <span style="${contentStyle}">${title}</span>
            </th>`;
        }
      });

      innerHtml += '</tr></thead><tbody>';

      bodyLines.forEach(function (body) {
        let splitedData = body[0].split(":");
        innerHtml += `
        <tr style="margin: 0px 10px !important;">
          <td><span style="${contentStyle}">${splitedData[0]}</span></td>
          <td><span style="${contentStyle}">${splitedData[1]}</span></td>
        </tr>`;
      });

      innerHtml += '</tbody>';

      var tableRoot = tooltipEl.querySelector('table');
      const sanitizedInnerHtml = this.sanitization.sanitizeHtml(innerHtml);
      tableRoot.innerHTML = sanitizedInnerHtml as string;
    }

    var position = chart.canvas.getBoundingClientRect();
    tooltipEl.style.opacity = 1;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.padding = '5px 10px';
    tooltipEl.style.pointerEvents = 'none';
  };
  
  floatToTime(floatValue: any) {
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(floatValue);
    const remainingMinutes = (floatValue - hours) * 60;
    const minutes = Math.floor(remainingMinutes);
    const seconds = Math.round((remainingMinutes - minutes) * 60);

    // Format the values as "hh:mm:ss"
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

}
